import { MobXProviderContext } from 'mobx-react';
import { useContext } from 'react';
var useAuthorizationStore = function () { return useContext(MobXProviderContext).authorizationStore; };
export default useAuthorizationStore;
//# sourceMappingURL=UseAuthorizationStore.js.map